import React from 'react'
import { FormattedMessage } from 'react-intl'
import PageTitle from '../PageTitle'
import { LanguageConsumer } from '../../context/LanguageContext'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import { ListingConsumer } from '../../context/ListingContext'
import AddNewForm from '../../FormFields/EntityAddForm'
import AddNewDialog from '../Dialog/AddNewDialog'
import LateSubmissionRequestsList from './RequestsList'
import { AuthConsumer } from '../../context/AuthContext'
import Configuration from '../../Services/Api/Configuration'
import { LateSubmissionProvider, LateSubmissionConsumer } from '../../context/LateSubmissionContext'
import { useStyles } from './Styles'

const LateSubmissionPageContent = () => {
  const classes = useStyles()
  return (
    <LateSubmissionProvider>
      <LateSubmissionConsumer>
        {({ lateSubmissionConf }) => (
          <AuthConsumer>
            {({ taxpayerData, userPermissions }) => (
              <ListingConsumer>
                {({ listingData, cancelDialog, isDialogOpen, openDialog, entityName, entityData, dialogActionSubmit, listingCount }) => (
                  <>
                    <PageTitle title={<>
                      <FormattedMessage id='LateSubmissionPageContent.PageTitle'/>
                      {!!lateSubmissionConf?.lateSubmissionQuata && <span className={classes.remaining}><FormattedMessage id='LateSubmissionPageContent.remaining'
                                        values={{ remaining: parseInt(lateSubmissionConf?.lateSubmissionQuata || 0) - parseInt(listingCount || 0) }}/></span>}
                    {!!entityName && entityName === 'lateSubmission' && !!entityData?.remainingQuota && <span className={classes.remaining}><FormattedMessage id='LateSubmissionPageContent.remaining' values={{remaining: parseInt(entityData?.remainingQuota)}}/></span>}
                    </>}
                               addNewButton={true}
                               disabledButton={!(taxpayerData.late_submission_enabled && userPermissions.includes(Configuration.permissions.lateSubmission))}
                               addButtonFunction={() => openDialog()}
                               addButtonText={<FormattedMessage id='LateSubmission.addNew'/>}
                               addButtonIcon={<AddOutlinedIcon/>}
                    />
                    <LanguageConsumer>
                      {({ locale }) => (
                        <>
                          <AddNewDialog
                            children={
                              <AddNewForm
                                entityName={entityName}
                                onSubmit={dialogActionSubmit}
                                cancelDialog={() => cancelDialog()}
                              />
                            }
                            // dialogAction={currentDialogAction}
                            DialogTitle={<FormattedMessage id={'LateSubmission.NewRequest'}/>}
                            isDialogOpen={isDialogOpen}
                            cancelDialog={() => cancelDialog()}
                          />
                          <LateSubmissionRequestsList listingData={listingData} locale={locale}/>
                        </>
                      )}
                    </LanguageConsumer>
                  </>
                )}
              </ListingConsumer>
            )}
          </AuthConsumer>
        )}
      </LateSubmissionConsumer>
    </LateSubmissionProvider>
  )
}

export default LateSubmissionPageContent